module.exports = __webpack_public_path__ + "static/media/img1.397da54a.jpg";